import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Download, Clock } from 'lucide-react';
const COUNTDOWN_KEY = 'antifomo_countdown_start';
const COUNTDOWN_DURATION = 24 * 60 * 60 * 1000;
function getTimeRemaining(): number {
  const stored = localStorage.getItem(COUNTDOWN_KEY);
  let startTime: number;
  if (stored) {
    startTime = parseInt(stored, 10);
  } else {
    startTime = Date.now();
    localStorage.setItem(COUNTDOWN_KEY, startTime.toString());
  }
  const elapsed = Date.now() - startTime;
  const remaining = COUNTDOWN_DURATION - elapsed;
  if (remaining <= 0) {
    const newStart = Date.now();
    localStorage.setItem(COUNTDOWN_KEY, newStart.toString());
    return COUNTDOWN_DURATION;
  }
  return remaining;
}
function formatTime(ms: number) {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
export function PricingSection() {
  const [remaining, setRemaining] = useState<number>(COUNTDOWN_DURATION);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setRemaining(getTimeRemaining());
    setMounted(true);
    const interval = setInterval(() => {
      setRemaining(getTimeRemaining());
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <Section background="accent" id="pricing" data-id="element-119">
      <div className="max-w-3xl mx-auto text-center" data-id="element-120">
        <div className="bg-slate-900 border border-slate-700 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-121">
          {/* Glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-20 bg-blue-500/20 blur-3xl" data-id="element-122"></div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-123">
            Consigue tu copia hoy
          </h2>
          <p className="text-slate-400 mb-8" data-id="element-124">
            Acceso inmediato al sistema que cambiará tu ejecución.
          </p>

          <div className="flex items-center justify-center mb-2" data-id="element-125">
            <span className="text-2xl text-slate-500 line-through mr-3" data-id="element-126">
              27€
            </span>
            <span className="text-6xl font-bold text-white" data-id="element-127">17€</span>
            <span className="text-slate-500 ml-3 text-xl" data-id="element-128">pago único</span>
          </div>
          <p className="text-orange-400 text-sm font-medium mb-8" data-id="element-129">
            🔥 Precio de lanzamiento — sube a 27€ pronto
          </p>

          <Button size="lg" fullWidth href="https://www.claridaddirecta.com/cart/57813856682365:1" className="text-lg mb-5 shadow-blue-500/25" data-id="element-130">
            Comprar ahora — 17€
          </Button>

          {/* Inline Countdown */}
          {mounted && <div className="flex items-center justify-center gap-2 mb-6 text-sm md:text-base" data-id="element-131">
              <Clock className="h-4 w-4 text-amber-400 flex-shrink-0" data-id="element-132" />
              <p className="text-slate-300" data-id="element-133">
                Oferta especial:{' '}
                <span className="text-white font-semibold" data-id="element-134">17€</span> solo por{' '}
                <span className="text-amber-400 font-bold font-mono tabular-nums tracking-wide" data-id="element-135">
                  {formatTime(remaining)}
                </span>
                . Luego sube a{' '}
                <span className="text-slate-400 line-through" data-id="element-136">27€</span>.
              </p>
            </div>}

          <div className="flex items-center justify-center gap-6 text-sm text-slate-400" data-id="element-137">
            <span className="flex items-center" data-id="element-138">
              <Download className="h-4 w-4 mr-2" data-id="element-139" />
              Descarga inmediata
            </span>
            <span className="flex items-center" data-id="element-140">
              <ShieldCheck className="h-4 w-4 mr-2" data-id="element-141" />
              Pago seguro
            </span>
          </div>
        </div>
      </div>
    </Section>;
}